// Libraries
const i18n = window.i18n(); // This is loaded from the DOM due to library conflict with bundling

const getCurrentLang = () => {
    let lang = 'en';
    const htmlElement = document.querySelector('html');

    if (htmlElement) {
        lang = htmlElement.getAttribute('lang');
    }

    return lang;
};

const translations = {
    add_details: {
        en: 'Add Details',
        fr: 'Ajouter des Détails',
    },
    additional_comments_label: {
        en: 'Location Description',
        fr: 'Description du lieu',
    },
    additional_comments_placeholder: {
        en: 'Location Description',
        fr: 'Description du lieu',
    },
    additional_comments_helper_text: {
        en: 'Add any additional notes to help describe where your road is located.',
        fr: 'Ajoutez tout autre détail pouvant nous aider à bien localiser la route.',
    },
    agree_label: {
        en: 'I consent to the collection, use, communication and retention of my personal information in accordance with the ',
        fr: "Je consens à la collecte, à l'utilisation, à la communication et à la conservation de mes renseignements personnels, conformément à ",
    },
    alert_icon: {
        en: 'Icon - Alert',
        fr: 'Icône - Alerte',
    },
    and: {
        en: ' and ',
        fr: ' et ',
    },
    at_intersection: {
        en: 'at',
        fr: 'Intersection',
    },
    browser_outdated_1: {
        en: 'Your web browser ',
        fr: 'Version du navigateur ',
    },
    browser_outdated_2: {
        en: 'is out of date.',
        fr: 'trop ancienne.',
    },
    browser_update_detail: {
        en: 'Update your browser for more security, speed and the best experience on this site.',
        fr: 'Une mise à jour de votre navigateur vous assurerait une expérience plus agréable sur le site, et une plus grande rapidité et sécurité en général.',
    },
    browser_update: {
        en: 'Update browser',
        fr: ' Mettre à jour le navigateur',
    },
    choose_landmark: {
        en: 'If there is no significant crossroad nearby, you may choose to enter the nearest highway exit or landmark.',
        fr: 'Pas d’intersection pertinente? Entrer un autre point de repère comme une sortie d’autoroute.',
    },
    city_nofill_label: {
        en: 'Road City, Town, County or Hamlet',
        fr: 'Municipalité dans laquelle la route est située',
    },
    city_nofill_placeholder: {
        en: 'Road City, Town, County or Hamlet',
        fr: 'Municipalité dans laquelle la route est située',
    },
    clear_input: {
        en: 'Clear input',
        fr: 'Effacer le champ',
    },
    club_website: {
        en: 'CAA Club Website',
        fr: 'Site Web d’un club CAA',
    },
    consent_email: {
        en: 'I consent to be emailed from CAA, and understand I can unsubscribe at any time.',
        fr: "J'accepte de recevoir les courriels de la CAA et comprends que je peux me désabonner en tout temps.",
    },
    consent_targeting: {
        en: 'Yes, my email address may be used for custom audience targeting on social media and other digital platforms.',
        fr: "Oui, j'accepte que mon adresse courriel soit utilisée pour des actions de ciblage par audiences personnalisées dans les médias sociaux ou autres plateformes numériques.",
    },
    contest_no_link: {
        en: 'contest rules',
        fr: 'le règlement du concours',
    },
    contest_link: {
        en: 'Contest Rules',
        fr: 'le Règlement du Concours',
    },
    continue: {
        en: 'Continue',
        fr: 'Continuer',
    },
    crossroad_label: {
        en: 'Nearest Crossroad',
        fr: 'Intersection la plus proche',
    },
    cyclist: {
        en: 'Cyclist',
        fr: 'Cycliste',
    },
    email_label: {
        en: 'Email Address',
        fr: 'Courriel', // need updated string translation
    },
    email_placeholder: {
        en: 'Email Address',
        fr: 'Courriel', // @TODO: need updated translation
    },
    events: {
        en: 'Events',
        fr: 'Événements',
    },
    get_around: {
        en: 'How do you get around?',
        fr: 'Comment vous déplacez-vous?',
    },
    get_to_know: {
        en: "Let's get to know you!",
        fr: 'Dites-nous-en plus sur vous!',
    },
    field_empty: {
        en: 'This field cannot be empty.',
        fr: 'Champ obligatoire.',
    },
    field_select: {
        en: 'Select a road issue',
        fr: 'Sélectionner un problème lié à la route',
    },
    firstname_label: {
        en: 'First Name',
        fr: 'Prénom',
    },
    firstname_placeholder: {
        en: 'First Name',
        fr: 'Prénom',
    },
    how_find_us: {
        en: 'How did you find us?',
        fr: 'Comment nous avez-vous trouvé?',
    },
    image_max_format: {
        en: 'Maximum 5 images (jpg, gif, png)',
        fr: 'Maximum de 5 images (jpg, gif, png)',
    },
    image_max: {
        en: 'Maximum of 5 images allowed',
        fr: 'Le maximum est de 5 images',
    },
    image_upload_label: {
        en: 'Upload Photos',
        fr: 'Téléverser des photos',
    },
    image_upload: {
        en: 'Select Photos',
        fr: 'Sélectionner des photos',
    },
    info_submitted: {
        en: 'Information has been submitted.',
        fr: 'Information bien reçue.',
    },
    invalid_email: {
        en: 'Invalid Email',
        fr: "Courriel n'est pas valide",
    },
    issue_cross_road: {
        en: 'Lack of/ unsafe infrastructure for crossing the road',
        fr: 'Passage pour piétons absent ou inadéquat',
    },
    issue_poor_cycling: {
        en: 'No or poor cycling infrastructure',
        fr: 'Infrastructures cyclables absentes ou déficientes',
    },
    issue_poor_infra: {
        en: 'Poor infrastructure maintenance (ex. crumbling pavement)',
        fr: 'Mauvais entretien des infrastructures',
    },
    issue_poor_road: {
        en: 'Poor road maintenance',
        fr: 'Route mal entretenue',
    },
    issue_poor_sign: {
        en: 'Poor road signs or road markings',
        fr: 'Mauvaise signalisation ou marquage',
    },
    issue_poor_transit: {
        en: 'Poor transit infrastructure',
        fr: 'Mauvaises infrastructures de transport en commun',
    },
    issue_poor_walk: {
        en: 'Poor walking infrastructure (ex. sidewalk obstructed)',
        fr: 'Trottoir en mauvais état',
    },
    issue_pothole: {
        en: 'Potholes',
        fr: 'Nids-de-poule',
    },
    issue_traffic: {
        en: 'Traffic congestion',
        fr: 'De la congestion',
    },
    issue_unpaved: {
        en: 'Unpaved roads',
        fr: 'Route non asphaltée',
    },
    issue_unsafe_cross: {
        en: 'Unsafe cross walk',
        fr: 'Passage piéton non sécuritaire',
    },
    lastname_label: {
        en: 'Last Name',
        fr: 'Nom de famille',
    },
    lastname_placeholder: {
        en: 'Last Name',
        fr: 'Nom de famille',
    },
    magazine: {
        en: 'CAA Magazine',
        fr: 'Magazine CAA',
    },
    manual_submit: {
        en: "If you can't find your road, you can: ",
        fr: 'Si vous ne trouvez pas la route recherchée, vous pouvez : ',
    },
    manual_vote: {
        en: 'Submit a manual nomination.',
        fr: 'Envoyez une nomination manuelle',
    },
    membership_label: {
        en: 'If you have a CAA Membership, enter your membership number (Optional)',
        fr: 'Si vous êtes membre CAA-Québec, entrez votre numéro de membre (optionnel)',
    },
    membership_placeholder: {
        en: 'Membership # (Optional)',
        fr: 'Numéro de membre (Facultatif)',
    },
    membership_validation_message: {
        en: 'You have entered an invalid membership number. Please try again.',
        fr: 'Vous avez inscrit un numéro de membre erroné. Veuillez réessayer.',
    },
    motorcyclist: {
        en: 'Motorcyclist',
        fr: 'Motocycliste',
    },
    motorist: {
        en: 'Car',
        fr: 'Voiture',
    },
    newspaper: {
        en: 'Newspaper',
        fr: 'Médias écrits',
    },
    other: {
        en: 'Other',
        fr: 'Autre',
    },
    other_reason: {
        en: 'Other reason for why this road is unsafe',
        fr: 'Autre raison pour laquelle cette route est inhabituelle', // @TODO: confrim string translation
    },
    other_text: {
        en: 'Other reason for why this road is unsafe',
        fr: 'Autre raison pour laquelle cette route est inhabituelle', // @TODO: confrim string translation
    },
    passenger: {
        en: 'Vehicle passenger (Car, Uber, Taxi, etc.)',
        fr: 'Covoiturage (auto, Uber, taxi, etc.)',
    },
    pedestrian: {
        en: 'Pedestrian',
        fr: 'Piéton',
    },
    please_policy_agree: {
        en: 'Please agree to the ',
        fr: 'Veuillez accepter la ',
    },
    please_remove_image: {
        en: 'Please remove some images.',
        fr: 'Veuillez supprimer des images.',
    },
    please_select_road: {
        en: 'Please select a road from the dropdown.',
        fr: 'SVP choisir une route dans le menu déroulant.',
    },
    please_valid_entry: {
        en: 'Please enter a valid entry.',
        fr: 'SVP entrer une réponse valide.',
    },
    policy_agree: {
        en: 'I agree to the Privacy Policy.',
        fr: 'J’accepte la Politique de confidentialité.',
    },
    policy_link: {
        en: 'Privacy Policy',
        fr: 'la Politique de confidentialité',
    },
    policy_no_link: {
        en: 'privacy policy.',
        fr: 'la politique de confidentialité.',
    },
    previous_step: {
        en: 'Previous Step',
        fr: 'Étape précédente',
    },
    promotion_email_label: {
        en: 'Yes, I am a CAA Member and would like to receive emails from CAA in the future (Please enter your CAA Membership number to ensure you receive these emails).',
        fr: "Oui, je suis un membre CAA-Québec et j'aimerais recevoir des courriels de CAA-Québec (Pour recevoir les courriels, SVP entrer votre numéro de membre).",
    },
    province_nofill_label: {
        en: 'Road Province',
        fr: 'Province dans laquelle la route est située',
    },
    province_nofill_placeholder: {
        en: 'Road Province',
        fr: 'Province dans laquelle la route est située',
    },
    radio: {
        en: 'Radio',
        fr: 'Radio',
    },
    road_concern: {
        en: 'Road Concern or Road Issue',
        fr: 'La nature du problème',
    },
    road_label: {
        en: 'Road Name',
        fr: 'Nom de la route',
    },
    road_select: {
        en: 'Select Your Road',
        fr: 'Voter pour cette route',
    },
    road_unsafe: {
        en: 'Reason for Nomination. Select all that apply',
        fr: 'En quoi cette route se qualifie-t-elle?',
    },
    select_multiple_users: {
        en: 'You may select multiple road users.',
        fr: "Vous pouvez sélectionner plusieurs types d'usagers de la route.",
    },
    select_multiple_options: {
        en: 'You can select more than one option.',
        fr: "Vous pouvez choisir plus d'une option.",
    },
    select_one_or_more: {
        en: 'Select one or more items.',
        fr: 'Sélectionner un ou plusieurs éléments.',
    },
    select_one_user: {
        en: 'Select at least one type of road user.',
        fr: 'Indiquez au moins un type d’usager de la route.',
    },
    select_all_that_apply: {
        en: '(Select all that apply)',
        fr: "(Choisissez tout ce qui s'applique)",
    },
    social_media: {
        en: 'Social media (Facebook, Twitter, YouTube, etc.)',
        fr: 'Médias sociaux (Facebook, Twitter, YouTube, etc.)',
    },
    step_road_complete: {
        en: "Make sure the that 'Road/Intersection' step is completed. Then add your details after.",
        fr: "Assurez-vous que l'étape 1, «route/intersection», soit complète avant d'ajouter d'autres détails.",
    },
    submit: {
        en: 'Submit Vote',
        fr: 'Soumettre',
    },
    success: {
        en: 'Success!',
        fr: 'Succès!',
    },
    transit: {
        en: 'Transit',
        fr: 'Transport en commun',
    },
    tv: {
        en: 'TV',
        fr: 'Télévision',
    },
    type_comments: {
        en: 'Type your comments here',
        fr: 'Écrivez vos commentaires ici',
    },
    type_road: {
        en: 'Start typing the road and select a road from the dropdown.',
        fr: 'Commencer à taper et choisir une route dans le menu déroulant.',
    },
    unable_submit: {
        en: 'Unable to Submit',
        fr: 'Problème D’envoi',
    },
    vote_now: {
        en: 'Submit Nomination',
        fr: 'Envoyer votre proposition',
    },
    vote_road: {
        en: 'Vote for your worst road',
        fr: 'Voter pour cette route',
    },
    recaptcha_please_verify: {
        en: 'Please verify that you are a human',
        fr: 'Veuillez vérifier que vous êtes humain',
    },
    you_have_selected: {
        en: 'You have selected',
        fr: 'Vous avez sélectionné',
    },
    terms_conditions: {
        en: 'Terms and Conditions',
        fr: 'Conditions générales',
    },
    required_info: {
        en: 'All fields required unless marked optional',
        fr: "Tous les champs sont obligatoires sauf s'ils sont marqués facultatifs",
    },
    optional: {
        en: '(Optional)',
        fr: '(Facultatif)',
    },
};

/**
 *
 * @param {string} field The name of the field being translated
 * @returns {string} Translated text in English or French
 */
const translate = (field, lang = null) => {
    let language = lang === null ? getCurrentLang() : lang;
    let returnText = '';

    if (translations[field] === undefined) {
        console.log(
            "The '" +
                field +
                "' variable provided cannot be found in the translation JSON object. Please try again."
        );
        return;
    }

    if (language === 'fr-CA') {
        returnText = translations[field]['fr'];
    } else {
        returnText = translations[field]['en'];
    }
    return returnText;
};

export { getCurrentLang, translate };
